module.exports = __webpack_public_path__ + "static/media/adventure-archive-screenshot-5.74cce66e.jpg";